import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Swal from "sweetalert2";
import PDF from "../../../../assets/images/pdf.svg";
import { getCampaignView } from "../../../../redux/actions/campaignActions";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import ProfilePic from "../../../../assets/images/dummy_profile.png";
import "../../../../components/common/css/campaignview.scss";
import Modal from "@mui/material/Modal";
import Close from "../../../../assets/images/close-icon.png";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";


const DeletedCampView = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [business_plan_docs, setBuiness_Plan_Docs] = useState([]);
  const [other_docs, setOther_Docs] = useState([]);
  const dispatch = useDispatch();
  const campaignView = useSelector((state) => state.campaignView);
  const { campaign } = campaignView;
  const id = useParams();
  let token = localStorage.getItem("accessToken");
  const d = new Date(campaign?.data[0]?.user?.dob);
  let campaign_id = campaign?.data[0]?.id?.toString()?.padStart(8, "0");
  const [open, setOpen] = useState(false);
  const [history, setHistory] = useState([]);
  const handleClose = () => setOpen(false);


  // useEffect(() => {
  //   dispatch(getCampaignView(token, id));
  // }, []);

  // useEffect(() => {
  //   if (campaignView) {
  //     if (campaignView?.loading !== undefined) {
  //       setLoading(campaignView?.loading);
  //     }
  //   }
  // }, [campaignView]);

  useEffect(() => {
    fetchuserCampaignData();
    viewHstory();
  }, []);

  const dateFormat = (date) => {
    const notificationDate = new Date(date);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let temp =
      months[notificationDate.getMonth()] +
      " " +
      notificationDate.getDate() +
      ", " +
      notificationDate.getFullYear() +
      "   at  " +
      notificationDate.getHours() +
      ":" +
      notificationDate.getMinutes();
    return temp;
  };

  const viewHstory = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/getAllLogsofCamapignbyId",
      headers: {
        "x-access-token": token,
      },
      data: {
        slug: campaign?.data[0]?.slug,
        user_id: campaign?.data[0]?.user_id,
        campaign_id: id.campaignId,
      },
    };
    axios(config)
      .then(function (response) {
        setLoading(false);
        // console.log(response?.data?.data?.rows);
        
        setHistory(response?.data?.data?.rows);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };
  // console.log(history,"xyz");
  // useEffect(() => {
  //   if (campaignView) {
  //     if (
  //       campaignView?.campaign?.status == 200 &&
  //       campaignView?.campaign?.success == true
  //     ) {
  //       viewHstory();
  //     }
  //   }
  // }, [campaignView]);

  const handleOpen = () =>{
    setOpen(true);
  }

  const fetchuserCampaignData = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    // setPageState((old) => ({ ...old }));
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/get-campaigndetailsby-id",
      headers: {
        "x-access-token": token,
      },
      data: {
        is_deleted: 1,
        campaign_id: id?.campaignId,
      },
    };

    axios(config)
      .then(function (response) {
        setData(response?.data?.data);
        setBuiness_Plan_Docs(
          response?.data?.data[0]?.business_plan_docs?.filter(
            (x) => x.is_other == 0
          )
        );
        setOther_Docs(
          response?.data?.data[0]?.business_plan_docs?.filter(
            (x) => x.is_other == 1
          )
        );
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error.response.data.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <Loader isLoading={loading} />
        <div className="top">
          {data?.map((userInfo, i) => (
            <>
              <div className="left">
                {/* <div className="editButton">Edit</div> */}
                <div className="title-topSection">
                <h1 className="title">Personal Information</h1>
                <button onClick={handleOpen} className="editButton">
                  History
                </button>
                </div>
                <div className="item">
                  <img
                    src={
                      userInfo.user.profilePic == null
                        ? ProfilePic
                        : userInfo.user.profilePic
                    }
                    alt=""
                    className="itemImg"
                  />
                  <div className="details profile-info">
                    {/* <h1 className="itemTitle">
                      {userInfo.user.firstname} {userInfo.user.lastname}
                    </h1> */}
                    <div className="detailItem">
                      <span className="itemKey">Name:</span>
                      <span className="itemValue">
                        <b>
                          {userInfo?.user?.salutations}{" "}
                          {userInfo.user.firstname} {userInfo?.user?.lastname}
                        </b>
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Email:</span>
                      <span className="itemValue">
                        {userInfo.user.email == null ? "" : userInfo.user.email}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Phone:</span>
                      <span className="itemValue">
                        {userInfo?.user?.phone === "null"
                          ? ""
                          : userInfo?.user?.phone}
                      </span>
                    </div>
                    {/* <div className="detailItem">
                      <span className="itemKey">Status:</span>

                      <span className="itemValue">
                        {userInfo.user.userStatus === 1 ? "Active" : "Inactive"}
                      </span>
                    </div> */}
                    <div className="detailItem">
                      <span className="itemKey">Current Address:</span>
                      <span className="itemValue">
                        {userInfo?.user?.current_address}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Floor:</span>
                      <span className="itemValue">
                        {userInfo?.user?.address}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">City:</span>
                      <span className="itemValue">{userInfo?.user?.city}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Postal Code:</span>
                      <span className="itemValue">
                        {userInfo?.user?.postal_code}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Country:</span>
                      <span className="itemValue">
                        {userInfo?.user?.user_country?.country_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">State/Province:</span>
                      <span className="itemValue">
                        {userInfo?.user?.user_state?.state_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">DOB:</span>
                      <span className="itemValue">
                        {d?.toLocaleDateString()}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Gender:</span>
                      <span className="itemValue">
                        {userInfo?.user?.gender}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Marital Status:</span>
                      <span className="itemValue">
                        {userInfo?.user?.marital_status}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Employer:</span>
                      <span className="itemValue">
                        {userInfo?.user?.employer}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Occupation:</span>
                      <span className="itemValue">
                        {userInfo?.user?.occupation}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Sin:</span>
                      <span className="itemValue">{userInfo?.user?.sin}</span>
                    </div>
                    {/* <div className="detailItem">
                      <span className="itemKey">Cell:</span>
                      <span className="itemValue">
                        {userInfo?.user?.mobile}
                      </span>
                    </div> */}
                  </div>
                </div>
                <span className="file-note-msg">
                  <b>Note</b>: This campaign is deleted.{" "}
                </span>
              </div>
              <div className="left">
                {/* <div className="editButton">Edit</div> */}
                <h1 className="title">Corporate Information</h1>
                <div className="item">
                  <div className="details profile-info">
                    <div className="detailItem">
                      <span className="itemKey">Campaign ID:</span>
                      <span className="itemValue">{campaign_id}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Company Name:</span>
                      <span className="itemValue">
                        {userInfo.corporation_legal_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Company Location:</span>
                      <span className="itemValue">{userInfo.city}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Campaign Type:</span>
                      <span className="itemValue">{userInfo.campaign_for}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Head Office Address</span>
                      <span className="itemValue">
                        {userInfo.registered_address}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Phone:</span>
                      <span className="itemValue">{userInfo?.phone}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Email:</span>
                      <span className="itemValue">{userInfo?.camp_email}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Country</span>
                      <span className="itemValue">
                        {userInfo?.user_country?.country_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">State/Province</span>
                      <span className="itemValue">
                        {userInfo?.user_state?.state_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Postal Code</span>
                      <span className="itemValue">{userInfo?.postal_code}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Type Of Enitity:</span>
                      <span className="itemValue">{userInfo.entitytype}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Website</span>
                      <span className="itemValue">{userInfo?.website}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Buisness No:</span>
                      <span className="itemValue">{userInfo.business}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Fax</span>
                      <span className="itemValue">{userInfo.fax}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Crax Acoount</span>
                      <span className="itemValue">
                        {userInfo.craax_account}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Date Of Corp</span>
                      <span className="itemValue">
                        {userInfo.date_of_incorp}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Incorp Register</span>
                      <span className="itemValue">
                        {userInfo?.in_corporation_registration}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Year Of Corporation</span>
                      <span className="itemValue">
                        {userInfo.how_many_yearsin_business}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Accredited</span>
                      <span className="itemValue">
                        {userInfo.is_acreadited === 1 ? "yes" : "No"}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Feature</span>
                      {Array.isArray(userInfo?.features) ? (
                        userInfo?.features.map((feature, index) => {
                          return (
                            <li className="itemValue">
                              {feature?.feature_title}
                            </li>
                          );
                        })
                      ) : (
                        <h4>No Data Found</h4>
                      )}
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Nature Of Buisness</span>
                      {Array.isArray(userInfo?.nature_of_businesses) ? (
                        userInfo?.nature_of_businesses.map((cat, index) => {
                          return (
                             <li className="itemValue">
                              {cat?.business_category?.category_name}
                            </li>
                          );
                        })
                      ) : (
                        <h4>No Data Found</h4>
                      )}
                    </div>
                    <div className="buisnessPlan">
                      <span className="itemKey">Buisness Plan Docs</span>
                      <div className="itemValue">
                        {business_plan_docs?.length > 0 ? (
                          business_plan_docs?.map((pdf, i) => (
                            <>
                              <a
                                href={pdf.document_name}
                                target="_blank"
                                className="docLink"
                              >
                                {pdf?.document_name !== null && (
                                  <img src={PDF} className="docImage" />
                                )}

                                {pdf?.document_name !== null && (
                                  <p className="docName">doc {i + 1}</p>
                                )}
                              </a>
                            </>
                          ))
                        ) : (
                          <h6>No Data Found</h6>
                        )}
                      </div>
                    </div>

                    <div className="buisnessPlan">
                      <span className="itemKey">Other Docs</span>
                      <div className="itemValue">
                        {other_docs?.length > 0 ? (
                          other_docs?.map((pdf, i) => (
                            <>
                              <a
                                href={pdf.document_name}
                                target="_blank"
                                className="docLink"
                              >
                                {pdf?.document_name !== null && (
                                  <img src={PDF} className="docImage" />
                                )}

                                {pdf?.document_name !== null && (
                                  <p className="docName">doc {i + 1}</p>
                                )}
                              </a>
                            </>
                          ))
                        ) : (
                          <h6>No Data Found</h6>
                        )}
                      </div>
                    </div>
                    <div className="buisnessPlan">
                        <span className="itemKey">Campaign Banner</span>
                        <div className="itemValue">
                          {userInfo?.banner_img != null ||
                          userInfo?.banner_img == !"" ? (
                            <img
                              src={
                                userInfo?.banner_img == null
                                  ? ProfilePic
                                  : userInfo?.banner_img
                              }
                              alt=""
                              className="itemCorpImg"
                            />
                          ) : (
                            "No Data Found"
                          )}
                        </div>
                      </div>
                      <div className="detailItem">
                      <span className="itemKey">Product:</span>
                      
                      <span className="itemValue">
                        
                        {userInfo?.product}
                      </span>
                      
                    </div>

                  </div>
                </div>
              </div>
              <div className="left">
                {/* <div className="editButton">Edit</div> */}
                <h1 className="title">Campaign related Questions/Answers</h1>
                <div className="item">
                  <div className="details profile-info">
                    {userInfo?.campaign_que_ans?.length > 0 ? (
                      userInfo?.campaign_que_ans?.map((que) => (
                        <div className="detailItem companyInfo" key={que.q_id}>
                          <span className="itemKey">{que.question}:</span>
                          <span className="itemValue">{que.answer}</span>
                        </div>
                      ))
                    ) : (
                      <h5>No Data Found</h5>
                    )}
                  </div>
                </div>
              </div>
              <div className="left">
                
                <h1 className="title">Bank Information</h1>

                <div className="item">
                  <div className="details profile-info">
                    <div className="detailItem">
                      <span className="itemKey">Bank Name:</span>
                      <span className="itemValue">
                        {userInfo?.profile_individual_bankdetails?.bank_name}
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Account Number</span>
                      <span className="itemValue">
                        {
                          userInfo?.profile_individual_bankdetails
                            ?.account_number
                        }
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Bank Institution:</span>
                      <span className="itemValue">
                        {userInfo?.profile_individual_bankdetails?.institution}
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Bank Transit Number</span>
                      <span className="itemValue">
                        {
                          userInfo?.profile_individual_bankdetails
                            ?.transit_number
                        }
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Bank Swift Code</span>
                      <span className="itemValue">
                        {
                          userInfo?.profile_individual_bankdetails
                            ?.swift_code
                        }
                      </span>
                    </div>

                    <div className=" idDocs">
                      <span className="itemKey">Bank Docs</span>
                      <div className="itemValue">
                        <a
                          href={
                            userInfo?.profile_individual_bankdetails?.bankdoc
                          }
                          target="_blank"
                          className="docLink"
                        >
                          {userInfo?.profile_individual_bankdetails?.bankdoc !==
                            null && <img src={PDF} className="docImage" />}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ))}
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box className="modal-popup">
              <div className="modal-top">
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Campaign Activity
                </Typography>
                <Button className="closeBtn" onClick={() => setOpen(false)}>
                  <img src={Close} alt="close-icon" />
                </Button>
              </div>
              <Typography id="modal-modal-description" sx={{ mt: 1 }}>
                <div className="new">
                  <div className="newContainer">
                    <div
                      className="bottom"
                      style={{ boxShadow: "none", padding: "0" }}
                    >
                      <div className="right">
                        <form className="accredited-investorForm">
                            
                        {history.length > 0 ? 
                          <div className="history-infoWrap">
                          {/* <p className="createdAt-value">
                            {dateFormat(history?.[0]?.timestamp)}
                          </p>
                           */}
                          {/* <p className="campName-value">
                            {
                              history?.[0]?.campaign_detail
                                ?.corporation_legal_name
                            }
                          </p> */}
                          {/* <p className="status-value">
                            {history?.[0]?.action}
                          </p> */}
                          <p className="campCreated-name">
                            {history?.[0]?.user?.firstname}
                            &nbsp;
                            {history?.[0]?.user?.lastname}&nbsp;Updated The Status to &nbsp;
                            {history?.[0]?.action}&nbsp;
                            on &nbsp;
                            {dateFormat(history?.[0]?.timestamp)}&nbsp;
                            For  &nbsp;
                            {
                              history?.[0]?.campaign_detail
                                ?.corporation_legal_name
                            }&nbsp; Campaign.
                          </p>
                        </div>
                        : <h3>No Data Found</h3>}

                        

                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </Typography>
            </Box>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default DeletedCampView;
